import { render, staticRenderFns } from "./viewsPresupuestos.vue?vue&type=template&id=7b1ab8e0&"
import script from "./viewsPresupuestos.vue?vue&type=script&lang=js&"
export * from "./viewsPresupuestos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports